import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";

//internal import
import ProjectService from "../services/ProjectService";
import { allContext } from "../context/AllContext";
import { notifySuccess, notifyError } from "../utils/toast";

const useProjectSubmit = (id) => {

    const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm();

    const { pageLoading, setPageLoading, dataUpdate, setDataUpdate } = useContext(allContext);

    const [isModal, setIsModal] = useState(false);
    const [isViewModal, setIsViewModal] = useState(false);
    const [isDeleteModal, setIsDeleteModal] = useState(false);
    const [viewData, setviewData] = useState([]);


    // add and update project details
    const onSubmit = async (data) => {
        setPageLoading(true);
        data.images = []
        try {
            const response = id ? await ProjectService.UpdateProjectById(id, data) : await ProjectService.addProject(data);
            if (response?.success) {
                notifySuccess(response.message);
                setDataUpdate(!dataUpdate);
                setIsModal(false);
            }
            else {
                notifyError(response.message);
            }
        } catch (error) {
            // console.error(error.message);
            // notifyError("Something went wrong.");
        } finally {
            setPageLoading(false);
        }
    };

    //  delete project by id 
    const handleDeleteProject = async (id) => {
        try {
            const response = await ProjectService.deleteProjectById(id);
            if (response.success) {
                notifySuccess(response?.message);
                setDataUpdate(!dataUpdate);
            }
            else {
                notifyError(response?.message);
            }
            setIsDeleteModal(false);
        }
        catch (error) {
            console.error("error", error);
            notifyError("Something want wrong !");
            setIsDeleteModal(false);
        }
    }

    useEffect(() => {
        reset();

        if (id) {
            (async () => {
                try {
                    const res = await ProjectService.getProjectById(id);
                    const data = res?.data;

                    if (res?.success) {
                        setviewData(data);
                        setValue("projectName", data.projectName);
                        setValue("projectCategory", data.projectCategory);
                        setValue("images", data.images);
                        setValue("projectStartDate", dayjs(data.projectStartDate).format("YYYY-MM-DD"));
                        setValue("projectEndDate", dayjs(data.projectEndDate).format("YYYY-MM-DD"));
                        setValue("assignPerson", data.assignPerson?._id);
                        setValue("priority", data.priority);
                        setValue("description", data.description);
                        setValue("projectStatus", data?.projectStatus);
                        setValue("status", data?.status);
                    }
                } catch (error) {
                    console.error("Error fetching Project data:", error);
                }
            })();
        }
    }, [isModal, id]);

    return {
        register,
        handleSubmit,
        setValue,
        errors,
        onSubmit,
        handleDeleteProject,
        pageLoading,
        isModal,
        setIsModal,
        isViewModal,
        setIsViewModal,
        isDeleteModal,
        setIsDeleteModal,
        viewData,
    }
}

export default useProjectSubmit;